import { State, Action, StateContext, Selector } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { ApiErros } from "./api_error.actions";
import { HttpErrorResponse } from "@angular/common/http";

export class ApiErrorStateModel {
	errors: { [url: string]: HttpErrorResponse };
}

@State<ApiErrorStateModel>({
	name: "apiError",
	defaults: {
		errors: {},
	},
})
@Injectable({
	providedIn: "root",
})
export class ApiErrorState {
	@Selector()
	static errors(state: ApiErrorStateModel) {
		return state.errors;
	}

	@Action(ApiErros.HandleError)
	getError(ctx: StateContext<ApiErrorStateModel>, action: ApiErros.HandleError) {
		const state = ctx.getState();
		ctx.patchState({
			errors: {
				...state.errors,
				[action.url]: action.error,
			},
		});
	}

	@Action(ApiErros.ClearErrors)
	clearErrors(ctx: StateContext<ApiErrorStateModel>) {
		ctx.patchState({ errors: {} });
	}

	@Action(ApiErros.RemoveError)
	removeError(ctx: StateContext<ApiErrorStateModel>, action: ApiErros.RemoveError) {
		const state = ctx.getState();
		const updated = { ...state.errors };
		delete updated[action.key];
		ctx.setState({ errors: updated });
	}
}
